import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  viewChild,
} from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatInput } from '@angular/material/input'
import { NgClass, NgForOf } from '@angular/common'
import { MatTooltip } from '@angular/material/tooltip'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { MatCheckbox } from '@angular/material/checkbox'
import moment from 'moment'
import { SnackbarCustomService } from '../snackbar/snackbar-custom.service'
import { ResponseRequestModel } from '../../../core/models/response.model'
import {
  ServiceOrderStatusService
} from '../../../core/services/service/service-order-status/service-order-status.service'
import { StretchTypeService } from '../../../core/services/stretch/stretch-type/stretch-type.service'

@Component({
  selector: 'form-passenger-logistics-search',
  imports: [
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    NgClass,
    MatTooltip,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatOption,
    MatSelect,
    MatCheckbox,
    NgForOf,
  ],
  templateUrl: './form-passenger-logistics-search.component.html',
  styleUrl: './form-passenger-logistics-search.component.scss',
})
export class FormPassengerLogisticsSearchComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private serviceOrderStatusService: ServiceOrderStatusService,
    private stretchTypeService: StretchTypeService,
  ) {}

  datepickerStart = viewChild<MatDatepicker<any>>('dateStart')
  datepickerEnd = viewChild<MatDatepicker<any>>('dateEnd')
  datepickerEmission = viewChild<MatDatepicker<any>>('dateEmission')

  formSearch: FormGroup = new FormGroup({})
  @Output() responseSearch = new EventEmitter()
  @Input() search = ''
  tipoTrechoList: any[] = []
  tipoLocalOptions = [
    { value: 'AEROPORTO', label: 'Aeroporto' },
    { value: 'ENDERECO', label: 'Endereço' },
  ]

  listStatus: any[] = []
  //   [
  //   { id: 0, description: 'Todos' },
  //   { id: 1, description: 'Aprovada' },
  //   { id: 2, description: 'Pendente' },
  //   { id: 3, description: 'Aguardando compras' },
  //   { id: 8, description: 'Devolvido Compras' },
  //   { id: 4, description: 'Análise do cliente' },
  //   { id: 5, description: 'Não aceita pelo cliente' },
  //   { id: 6, description: 'Cancelada' },
  //   { id: 7, description: 'Em aberto' },
  // ]

  ngOnInit() {
    this.createForm()
    this.getTipoTrecho()
  }
  getTipoTrecho() {
    this.stretchTypeService.listStretchType().subscribe({
      next: (res) => {
        this.tipoTrechoList = res.data
      },
      error: (err) => {
        console.error('Erro ao buscar tipos de trecho', err)
      },
    })
  }
  ngOnChanges() {
    // this.updateSearch()
  }

  createForm(): void {
    this.formSearch = this.formBuilder.group({
      nome: [''],
      documento: [''],
      contato: [''],
      cpf: [''],

      tipoTrecho: [null],

      destinoOrigemVoo: [''],

      data: [null as Date | null],
      vooData: [null as Date | null],

      companhia: [''],
      voo: [''],

      apenasComVoo: [false],
      apenasSeVoo: [false],

      origemTipo: [null],
      origemCidade: [''],
      origemAeroSigla: [''],

      destinoTipo: [null],
      destinoCidade: [''],
      destinoAeroSigla: [''],
    })
  }

  sendSearch(search = true) {
    if (search && this.checkSearch()) {
      const searchModel = {
        nome: this.formSearch.value.nome,
        documento: this.formSearch.value.documento,
        contato: this.formSearch.value.contato,
        cpf: this.formSearch.value.cpf,

        tipoTrechoId: this.formSearch.value.tipoTrecho,

        destinoOrigemVoo: this.formSearch.value.destinoOrigemVoo,

        data: this.formSearch.value.data ? moment(this.formSearch.value.data).format('YYYY-MM-DD') : null,
        vooData: this.formSearch.value.vooData ? moment(this.formSearch.value.vooData).format('YYYY-MM-DD') : null,


        companhia: this.formSearch.value.companhia,
        voo: this.formSearch.value.voo,

        apenasComVoo: this.formSearch.value.apenasComVoo === true ? true : null,
        apenasSeVoo: this.formSearch.value.apenasSeVoo === true ? true : null,

        origemTipo: this.formSearch.value.origemTipo,
        origemCidade: this.formSearch.value.origemCidade,
        origemAeroSigla: this.formSearch.value.origemAeroSigla,

        destinoTipo: this.formSearch.value.destinoTipo,
        destinoCidade: this.formSearch.value.destinoCidade,
        destinoAeroSigla: this.formSearch.value.destinoAeroSigla,
      }
      this.responseSearch.emit({ search: search, model: searchModel })
    } else if (!search) {
      this.formSearch.patchValue({
        nome: '',
        documento: '',
        contato: '',
        cpf: '',

        tipoTrecho: null,

        destinoOrigemVoo: '',

        data: null as Date | null,
        vooData: null as Date | null,

        companhia: '',
        voo: '',

        apenasComVoo: false,
        apenasSeVoo: false,

        origemTipo: null,
        origemCidade: '',
        origemAeroSigla: '',

        destinoTipo: null,
        destinoCidade: '',
        destinoAeroSigla: '',
      })

      this.responseSearch.emit({
        search: false,
        model: {},
      })
    }
  }

  checkSearch() {
    if (
      this.formSearch.get('nome')!.value.trim().length > 0 ||
      this.formSearch.get('documento')!.value.trim().length > 0 ||
      this.formSearch.get('contato')!.value.trim().length > 0 ||
      this.formSearch.get('cpf')!.value.trim().length > 0 ||
      this.formSearch.get('tipoTrecho')!.value != null ||
      this.formSearch.get('destinoOrigemVoo')!.value.trim().length > 0 ||
      this.formSearch.get('data')!.value != null ||
      this.formSearch.get('vooData')!.value != null ||
      this.formSearch.get('companhia')!.value.trim().length > 0 ||
      this.formSearch.get('voo')!.value.trim().length > 0 ||
      this.formSearch.get('apenasComVoo')!.value === true ||
      this.formSearch.get('apenasSeVoo')!.value === true ||
      this.formSearch.get('origemTipo')!.value != null ||
      this.formSearch.get('origemCidade')!.value.trim().length > 0 ||
      this.formSearch.get('origemAeroSigla')!.value.trim().length > 0 ||
      this.formSearch.get('destinoTipo')!.value != null ||
      this.formSearch.get('destinoCidade')!.value.trim().length > 0 ||
      this.formSearch.get('destinoAeroSigla')!.value.trim().length > 0
    ) {
      return true
    } else {
      return false
    }
  }

  checkForm() {
    const input = this.formSearch.get('event')?.value
    if (input.trim().length == 0 || input.trim().length > 3) {
      return true
    } else {
      return false
    }
  }

  openDatepicker(type: 'dateStart' | 'dateEnd' | 'dateEmission') {
    if (type == 'dateStart') {
      this.datepickerStart()?.open()
    } else if (type == 'dateEnd') {
      this.datepickerEnd()?.open()
    } else if (type == 'dateEmission') {
      this.datepickerEmission()?.open()
    }
  }
}
